import { useState } from "react";
import { useCms } from "./useCms";
import { Field, Panel, AddButton } from "./Fields";
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";

const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export default function ArticlesEditor() {
  const { data, setData, save, saving } = useCms("articles", []);
  const list = Array.isArray(data) ? data : [];
  const [open, setOpen] = useState(null);
  const update = (i, patch) => setData(list.map((a, idx) => (idx === i ? { ...a, ...patch } : a)));

  return (
    <Panel title={`Blog Articles (${list.length})`} description="Content supports HTML (<h2>, <p>, <ul>). Slug becomes the URL: /blog/<slug>. Changing a slug of a published article breaks old links." onSave={() => save(list)} saving={saving} saveTestid="articles-save">
      <div className="space-y-2">
        {list.map((a, i) => (
          <div key={a.slug || i} data-testid={`article-row-${i}`} className="rounded-xl border border-slate-200">
            <div className="flex items-center justify-between p-3">
              <button type="button" className="text-left flex-1" data-testid={`article-toggle-${i}`} onClick={() => setOpen(open === i ? null : i)}>
                <p className="font-semibold text-slate-900 text-sm">{a.title || "Untitled article"}</p>
                <p className="text-xs text-slate-500">/blog/{a.slug} · {a.category} · {a.updated}</p>
              </button>
              <Button size="icon" variant="ghost" data-testid={`article-delete-${i}`} className="h-8 w-8 text-red-600" onClick={() => setData(list.filter((_, j) => j !== i))} aria-label="Delete"><Trash2 className="w-4 h-4" /></Button>
            </div>
            {open === i && (
              <div className="p-4 pt-0 space-y-3 border-t border-slate-100">
                <div className="grid md:grid-cols-2 gap-3 mt-3">
                  <Field label="Title" value={a.title} onChange={(v) => update(i, { title: v, slug: a.slug || slugify(v) })} testid={`article-title-${i}`} />
                  <Field label="Slug" value={a.slug} onChange={(v) => update(i, { slug: slugify(v) })} testid={`article-slug-${i}`} />
                  <Field label="Category" value={a.category} onChange={(v) => update(i, { category: v })} />
                  <Field label="Author" value={a.author} onChange={(v) => update(i, { author: v })} />
                  <Field label="Updated date (YYYY-MM-DD)" value={a.updated} onChange={(v) => update(i, { updated: v })} />
                </div>
                <Field label="Excerpt (used as meta description)" multiline value={a.excerpt} onChange={(v) => update(i, { excerpt: v })} />
                <Field label="Content (HTML)" multiline value={a.content} onChange={(v) => update(i, { content: v })} testid={`article-content-${i}`} />
              </div>
            )}
          </div>
        ))}
      </div>
      <AddButton label="Add article" testid="article-add" onClick={() => { setData([...list, { slug: "", title: "", category: "Guides", author: "Mashara Finance Team", updated: new Date().toISOString().slice(0, 10), excerpt: "", content: "" }]); setOpen(list.length); }} />
    </Panel>
  );
}
